import { DEMO_CALCULATOR_STEP } from 'config/constants'
export const DEMO_CALCULATOR_STEPS = [
  DEMO_CALCULATOR_STEP.MAIN,
  DEMO_CALCULATOR_STEP.PACKAGING,
  DEMO_CALCULATOR_STEP.DELIVERY,
  DEMO_CALCULATOR_STEP.CUSTOMS,
  DEMO_CALCULATOR_STEP.CERTIFICATION,
  DEMO_CALCULATOR_STEP.BANKING_COMMISSIONS,
  DEMO_CALCULATOR_STEP.ADDITIONAL_SERVICES,
] as const

export const DEMO_ANIMATION_START_STEP: DemoCalculatorStep = DEMO_CALCULATOR_STEP.MAIN

export const DEMO_MAIN_SAVE_EVENT = 'demo:main-save-complete'
export const DEMO_INVOICE_READY_EVENT = 'demo:invoice-ready'
export const DEMO_INVOICE_SAVE_EVENT = 'demo:invoice-save-complete'
export const DEMO_INVOICE_DATE_OPEN_EVENT = 'demo:invoice-date-open'
export const DEMO_INVOICE_DATE_CHOOSE_EVENT = 'demo:invoice-date-choose'
export const DEMO_INVOICE_LOCATION_SEARCH_EVENT = 'demo:invoice-location-search'
export const DEMO_INVOICE_LOCATION_CHOOSE_EVENT = 'demo:invoice-location-choose'
export const DEMO_PRODUCT_READY_EVENT = 'demo:product-ready'
export const DEMO_PRODUCT_SAVE_EVENT = 'demo:product-save-complete'
export const DEMO_PRODUCT_COUNTRY_SEARCH_EVENT = 'demo:product-country-search'
export const DEMO_PACKAGING_COMPLETE_EVENT = 'demo:packaging-playback-complete'
export const DEMO_STEP_PLAYBACK_COMPLETE_EVENT = 'demo:step-playback-complete'
export const DEMO_DELIVERY_SET_FIELD_EVENT = 'demo:delivery-set-field'
export const DEMO_DELIVERY_LOCATION_SEARCH_EVENT = 'demo:delivery-location-search'
export const DEMO_DELIVERY_LOCATION_CHOOSE_EVENT = 'demo:delivery-location-choose'
export const DEMO_DELIVERY_DATE_OPEN_EVENT = 'demo:delivery-date-open'
export const DEMO_DELIVERY_DATE_CHOOSE_EVENT = 'demo:delivery-date-choose'
export const DEMO_BANK_COMMISSION_INVOICE_READY_EVENT = 'demo:bank-commission-invoice-ready'
export const DEMO_PLAYBACK_START_EVENT = 'demo:playback-start'
export const DEMO_PLAYBACK_END_EVENT = 'demo:playback-end'
export const DEMO_FILL_ADDITIONAL_FIELDS_ACTION = 'fill-additional-fields'
export const DEMO_SAVE_ADDITIONAL_FIELDS_ACTION = 'save-additional-fields'

export const DEMO_INITIAL_DELAY = 900
export const DEMO_SCROLL_DELAY = 500
export const DEMO_SCROLL_SPEED = 2
export const DEMO_CHARACTER_DELAY = 55
export const DEMO_CLICK_DELAY = 500
export const DEMO_STEP_DELAY = 450
export const DEMO_ADDITIONAL_SERVICES_READING_DELAY = 2000
export const DEMO_CUSTOMS_READING_SCROLL_DISTANCE = 240
export const DEMO_CUSTOMS_READING_SCROLL_DELAY = 800
export const DEMO_CUSTOMS_READING_DURATION = DEMO_CUSTOMS_READING_SCROLL_DELAY * 3

export const DEMO_DELIVERY_FIELD_NAMES = {
  locationFrom: 'location_from',
  locationTo: 'location_to',
  plannedShipmentDate: 'planned_shipment_date',
} as const

export const DEMO_INVOICE_STAGE_SELECTORS = [
  '.invoice-form__description',
  '.invoice-form__supplier',
  '.invoice-form__invoice_num',
  '.invoice-form__invoice_date',
  '.invoice-form__incoterms',
  '.invoice-form__location',
]

export const DEMO_INVOICE_STATIC_VALUE_SELECTOR = [
  '.MuiPickersInputBase-sectionsContainer',
  '.MuiSelect-select',
  '.location-value',
].join(', ')
